import { render, staticRenderFns } from "./create-tab.vue?vue&type=template&id=1cf8c3a7"
import script from "./create-tab.vue?vue&type=script&lang=js"
export * from "./create-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports